function normalizeSupplierCategoryText(value = "") {
  return String(value)
    .toLowerCase()
    .replace(/&amp;|&#038;|&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

function singularizeToken(token) {
  if (token.endsWith("ies") && token.length > 4) {
    return `${token.slice(0, -3)}y`;
  }

  if (token.endsWith("s") && token.length > 3) {
    return token.slice(0, -1);
  }

  return token;
}

function getCategoryTokens(value = "") {
  return normalizeSupplierCategoryText(value)
    .split(/\s+/)
    .filter(
      (token) =>
        token && !["and", "medical", "device", "devices"].includes(token),
    )
    .map(singularizeToken);
}

export function supplierCategoryMatchesCategory(category, supplierCategory) {
  const normalizedCategory = normalizeSupplierCategoryText(category);
  const normalizedSupplierCategory =
    normalizeSupplierCategoryText(supplierCategory);

  if (!normalizedCategory || !normalizedSupplierCategory) {
    return false;
  }

  if (
    normalizedCategory === normalizedSupplierCategory ||
    normalizedCategory.includes(normalizedSupplierCategory) ||
    normalizedSupplierCategory.includes(normalizedCategory)
  ) {
    return true;
  }

  const categoryTokens = getCategoryTokens(category);
  const supplierTokens = getCategoryTokens(supplierCategory);

  return categoryTokens.some(
    (token) => token.length >= 4 && supplierTokens.includes(token),
  );
}

export function getMatchingSupplierCategories(
  categories = [],
  supplierCategories = [],
) {
  return supplierCategories.filter((supplierCategory) =>
    categories.some((category) =>
      supplierCategoryMatchesCategory(category, supplierCategory),
    ),
  );
}
